import Skeleton from '@mui/material/Skeleton';
import { Table, TableBody, TableRow } from 'shared/mui/Table';

import { StyledCard, StyledCardHeader } from './OrderConversionListOrders.styled';
import {
  TableCellHeaderStyled,
  TableCellStyled,
} from './OrderConversionListOrdersTableRow/OrderConversionListOrdersTableRow.styled';

export const OrderConversionListOrdersSkeleton: React.FC = () => (
  <StyledCard>
    <StyledCardHeader title={<Skeleton variant="text" width={240} />} titleSize="smallBold" />
    <Table>
      <TableBody>
        {Array.from({ length: 13 }).map((_, index) => (
          <TableRow key={index}>
            <TableCellHeaderStyled label={<Skeleton variant="text" width={120} />} />
            <TableCellStyled>
              <Skeleton sx={{ marginLeft: 'auto' }} variant="text" width={40} />
            </TableCellStyled>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </StyledCard>
);
